import {
  selectedPropertyId,
  isSavingProperty,
  googleProperties,
} from '../state'
import { savePropertySelection } from '../../../services/google/methods/save-property-selection'
import { integrations, showGoogleStatusModal } from '../../use-integration-management/state'
// i18n will be passed as parameter
import { responseHandlerService } from '@/plugins/responseHandlerService'

/**
 * Saves the selected Google Analytics property
 * @returns {Promise<boolean>} Success status
 */
export const saveGooglePropertySelection = async (t) => {

  if (!selectedPropertyId.value) return false

  isSavingProperty.value = true

  // Find selected property details
  const selectedProperty = googleProperties.value.find(
      (p) => p.id === selectedPropertyId.value,
  )

  try {
    const success = await savePropertySelection(
        selectedPropertyId.value,
        selectedProperty ? selectedProperty.displayName : '',
    )

    if (success) {
      // After successful property selection, mark Google integration as connected
      const googleIntegration = integrations.value.find((i) => i.id === 6)
      if (googleIntegration) {
        googleIntegration.connected = true
      }

      responseHandlerService.handleSuccess(
          'Başarılı bir şekilde entegre edildi.',
      )
      
      // Kapatma işlemini ekleyelim - modalyı kapatarak kullanıcı deneyimini iyileştirelim
      showGoogleStatusModal.value = false

      return true
    } else {
      responseHandlerService.handleError(
          null,
          'Bir hata oluştu.',
      )
      return false
    }
  } catch (error) {
    responseHandlerService.handleError(
        error,
        'Bir hata oluştu.',
    )
    return false
  } finally {
    isSavingProperty.value = false
  }
}
